import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';
import FeaturePhoneMock from './FeaturePhoneMock';

const VARIANTS = ['mood', 'followup', 'people'];

export default function Features() {
  const { t } = useLanguage();

  return (
    <section id="features" className="bg-ev-lime py-24 md:py-32 px-6 md:px-10" data-testid="features-section">
      <div className="max-w-[1500px] mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-light text-ev-ink lowercase text-center mb-16 md:mb-20 max-w-[1100px] mx-auto"
          style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.03em' }}>
          {t.ft_h}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {t.ft_columns.map((col, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="flex flex-col"
              data-testid={`feature-col-${i}`}>
              <FeaturePhoneMock variant={VARIANTS[i] || 'mood'} />
              <div className="mt-6 md:mt-8">
                <h3 className="font-display text-2xl md:text-3xl text-ev-ink lowercase mb-3">{col.title}</h3>
                <p className="font-body text-sm md:text-base text-ev-ink/75 leading-relaxed">{col.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
